export const SET_ARTICULOS = 'SET_ARTICULOS';
export const SET_SOLO_GENERICO = 'SET_SOLO_GENERICO';

export const SET_DOCUMENTOS = 'SET_DOCUMENTOS';
export const UPDATE_DOCUMENTOS = 'UPDATE_DOCUMENTOS';

export const SET_CORREO = 'SET_CORREO';
export const SET_LIMPIAR_FACTURACION = 'SET_LIMPIAR_FACTURACION';
export const SET_ASIGNAR_IMPORTE = 'SET_ASIGNAR_IMPORTE';

export const setArticulos = (data) => {
    return {
        type: SET_ARTICULOS,
        payload: data
    }
};

export const setDocumentos = (data) => {
    return {
        type: SET_DOCUMENTOS,
        payload: data
    }
};

export const updateDocumentos = (data) => {
    return {
        type: UPDATE_DOCUMENTOS,
        payload: data
    }
};

export const setSoloGenerico = (data) => {
    return {
        type: SET_SOLO_GENERICO,
        payload: data
    }
};

export const setCorreo = (data) => {
    return {
        type: SET_CORREO,
        payload: data
    }
};

export const setLimpiarFacturacion = () => {
    return {
        type: SET_LIMPIAR_FACTURACION
    }
};

export const setReciboPagoImporte = (data) => {
    return {
        type: SET_ASIGNAR_IMPORTE
    }
};